<script setup lang="ts">
// ================================
// Un texte dont les montants signés prennent leur couleur (revue du 08/10,
// retour R1) : « + » en vert, « − » en rouge, le reste tel quel. La couleur
// accompagne le signe déjà écrit, elle ne le remplace jamais ; le texte lu ou
// copié reste exactement le même.
// ================================
import { computed } from "vue"
import {
    classeSegment,
    segmenterMontants,
} from "@modules/courtage/utils/optim-turpe-v2.montant"

const props = defineProps<{ texte: string | null | undefined }>()

const getSegments = computed(() => segmenterMontants(props.texte))
</script>

<template>
    <template v-for="(segment, index) in getSegments" :key="index">
        <span
            v-if="segment.sens"
            :class="classeSegment(segment.sens)"
            :data-sens="segment.sens"
            >{{ segment.texte }}</span
        ><template v-else>{{ segment.texte }}</template>
    </template>
</template>
